import { RemoteGetCompletedEvaluationDetails } from 'data/usecases';
import { GetCompletedEvaluationDetailsUseCaseInterface } from 'domain/usecases';
import { makeApiUrlCompletedEvaluationDetails } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteGetCompletedEvaluationDetails =
  (): GetCompletedEvaluationDetailsUseCaseInterface =>
    new RemoteGetCompletedEvaluationDetails(
      makeApiUrlCompletedEvaluationDetails(),
      makeAxiosHttpClient(),
    );
